import { render, staticRenderFns } from "./DefaultCompanyJobList.vue?vue&type=template&id=6237ecd6&scoped=true"
import script from "./DefaultCompanyJobList.vue?vue&type=script&lang=js"
export * from "./DefaultCompanyJobList.vue?vue&type=script&lang=js"
import style0 from "./DefaultCompanyJobList.vue?vue&type=style&index=0&id=6237ecd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6237ecd6",
  null
  
)

export default component.exports